import {serializr, indirectReference, classConstructorParam, indirectObject, funct } from '@mecatran/serializr-extensions';
import * as model from "./model.mjs";
import { RouterConfig } from './model.mjs';
import {banServicesConfigModel} from "@mecatran/ban-services-lib-config";



var {SearchConfig} = banServicesConfigModel;
var BanSearchConfig = SearchConfig;



export {serializr};
export var configModel = model;


// =========
// variables
// --------- 
var {   createModelSchema, 
    createSimpleSchema, 
    primitive, 
    reference, 
    date, raw, list, object, 
    optional, alias,
    identifier, map, mapAsArray , 
    custom, 
    getDefaultModelSchema, 
    setDefaultModelSchema,
    serialize, 
    deserialize } = serializr;

  
function factory(clazz ){
    return function(){
        return new clazz();
    }
}


export var schemaUrbiplanApiStopConfig = {  // TMP To be replaced by a shema in the urbiplanApiConfig 
    factory : factory(model.UrbiplanApiStopConfig),
    props : {
        instance: primitive(),
        env: primitive(),
        key : primitive(),
    }
}






// ============================

function classIdentifier(provider){
    console.log('provider',provider)
    if (provider === 'urbiplan') return model.UrbiplanApiStopConfig;
    if (provider === 'sig-belfort') return model.BelfortSigConfig;
    if (provider === 'ban-search') return BanSearchConfig;
}


var schemaConfig = {
    factory : factory(model.Config),
    props : {
        datasetProviders : list(object(model.Provider)),
        defaultDatasetProviderConfigName : true, 
        routerConfigs : list(object(model.RouterConfig)),
        href : object(model.HRef)
    }
}

var schemaProvider = {
    factory : factory(model.Provider),
    props : {
        provider : true,
        name : true, 
        config : indirectObject(classIdentifier, 'provider') 
    }
}

var schemaBelfortSigConfig = {
    factory : factory(model.BelfortSigConfig),
    props : {
        url : true
    }
}

var schemaRouterConfig = {
    factory : factory(model.RouterConfig),
    props : {
        test : funct(),
        viewConfigName : true 
    }
}

var schemaHRefConfig = {
    factory : factory(model.HRef),
    props : {
        computeTitleUrl : funct(), 
        computeAlertTitleUrl : funct()
    }
}


setDefaultModelSchema(model.UrbiplanApiStopConfig, schemaUrbiplanApiStopConfig)
setDefaultModelSchema(model.Provider, schemaProvider);
setDefaultModelSchema(model.BelfortSigConfig, schemaBelfortSigConfig);
setDefaultModelSchema(model.Config, schemaConfig);
setDefaultModelSchema(model.RouterConfig, schemaRouterConfig);
setDefaultModelSchema(model.HRef, schemaHRefConfig )





